import menuCategoryApi from '@/api/menu-category'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const getDefaultState = () => ({
  id: 0,
  menuVersionId: 0,
  sortOrder: 0,
  translations: [
    {
      language: 'ru',
      name: null,
    },
    {
      language: 'ky',
      name: null,
    },
    {
      language: 'en',
      name: null,
    }
  ],
  errors: {
    errors: [],
  },
})

const state = getDefaultState()

const getters = {}

const actions = {
  create({ commit }) {
    return menuCategoryApi.create(state)
      .then(({ data }) => commit('MENU_CATEGORY_CREATED', data))
      .catch((error) => {
        commit('MENU_CATEGORY_CREATE_FAILED', error.response.data)
        throw error
      })
  },
  fetchById({ commit }, id) {
    commit('FORM_RESET')
    menuCategoryApi.getById(id)
      .then(({ data }) => commit('MENU_CATEGORY_FETCHED', data))
      .catch(err => commit('MENU_CATEGORY_FETCH_FAILED', err))
  },
  update({ commit }) {
    return menuCategoryApi.update(state)
      .then(({ data }) => commit('MENU_CATEGORY_UPDATED', data))
      .catch((error) => {
        commit('MENU_CATEGORY_UPDATE_FAILED', error.response.data)
        throw error
      })
  },
  resetForm({ commit }) {
    commit('FORM_RESET')
  },
}

const mutations = {
  SET_LIST(state, data) {
    state.list = data
  },
  MENU_CATEGORY_CREATED() {
    store.dispatch('message/success', 'CONTACT.created')
    store.dispatch('menuCategory/fetchList')
  },
  MENU_CATEGORY_CREATE_FAILED(state, errors) {
    state.errors.errors = errors.validationErrors
    store.dispatch('message/error', 'CONTACT.failedCreate')
  },
  MENU_CATEGORY_UPDATED() {
    store.dispatch('message/success', 'CONTACT.updated')
    store.dispatch('menuCategory/fetchList')
  },
  MENU_CATEGORY_UPDATE_FAILED(state, errors) {
    state.errors.errors = errors.validationErrors
    store.dispatch('message/error', 'CONTACT.failedUpdate')
  },
  FORM_RESET(state) {
    Object.assign(state, getDefaultState())
  },
  MENU_CATEGORY_FETCHED(state, data) {
    Object.assign(state, data)
  },
  ...generateFormHandlerMutations(state),
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
